var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _vm.index !== 0
      ? _c("i", {
          staticClass: "el-icon-remove-outline",
          on: {
            click: function ($event) {
              return _vm.delOneData()
            },
          },
        })
      : _vm._e(),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.index == 0,
            expression: "index ==0",
          },
        ],
        staticClass: "span4",
        on: {
          click: function ($event) {
            return _vm.addSpotType("和")
          },
        },
      },
      [_vm._v("和")]
    ),
    _c(
      "span",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.index == 0,
            expression: "index ==0",
          },
        ],
        staticClass: "span4",
        on: {
          click: function ($event) {
            return _vm.addSpotType("或")
          },
        },
      },
      [_vm._v("或")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }